/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGroupDetail: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-group-detail", jiraSpaEntry: "async-jira-eoc-group-detail" */ '@jira/eoc__group-detail/src/ui/index.tsx'
		),
);

const AsyncGroupDetail = (): React.JSX.Element => (
	<LazyPage Page={LazyGroupDetail} pageId="async-jira-eoc-group-detail" shouldShowSpinner={false} />
);

export default AsyncGroupDetail;
